import { createContext, useContext, useEffect, useState } from "react";

const AffiliateContext = createContext();

export function useAffiliate() {
  return useContext(AffiliateContext);
}

export function AffiliateProvider({ children }) {
  const [affiliateId, setAffiliateId] = useState(
    () => localStorage.getItem("affiliate_id") || null
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      setAffiliateId(ref);
      localStorage.setItem("affiliate_id", ref);
    }
  }, []);

  return (
    <AffiliateContext.Provider value={{ affiliateId }}>
      {children}
    </AffiliateContext.Provider>
  );
}
